module.exports = __webpack_public_path__ + "static/wl-hero-light-3f3f6c980f338fff45ee1d66b91c4b80.png";